import React from 'react';
import {Grid} from 'semantic-ui-react';

import ConnectedHomepageColumn from 'components/homepage-layouts/HomepageColumnContainer';

class HomepageSection extends React.Component {

  render() {
    return  <Grid columns={this.props.section.columns.length}>
              {this.props.section.columns.map((column, i) => (
                <ConnectedHomepageColumn column={column}  section={this.props.section} />
              ))}
            </Grid>
  }

}

export default HomepageSection;



// WEBPACK FOOTER //
// ./public/components/homepage-layouts/HomepageSection.jsx